<template>
  <el-container id="layout-container" class="app-wrapper" v-if="$store.getters.topNav" >
    <el-header class="layout-nav" :style="{'background-color': this.$store.getters.theme}">
      <NavMenu/>
    </el-header>
    <el-container class="body-container">
      <el-aside style="width: auto; z-index: 2;">
        <Sidebar/>
      </el-aside>
      <el-container>
        <el-header class="breadcrumb" v-if="showBreadcrumb">
          <NavBreadcrumb/>
        </el-header>
        <el-main style="padding: 0;">
          <AppMain/>
        </el-main>
      </el-container>
    </el-container>
  </el-container>

  <el-container v-else id="layout-container" class="app-wrapper">
    <el-aside style="width: auto; z-index: 2; height: 100%;">
      <Sidebar/>
    </el-aside>
    <el-container style="height: 100%;">
      <el-header class="layout-nav" :style="{'background-color': this.$store.getters.theme}">
        <NavMenu/>
      </el-header>
      <el-container class="body-container">
        <el-header class="breadcrumb" v-if="showBreadcrumb">
          <NavBreadcrumb/>
        </el-header>
        <el-main style="padding: 0;">
          <AppMain/>
        </el-main>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import {AppMain, NavBreadcrumb, NavMenu, Sidebar} from './layout.js'
import adapter from './adapter'

export default {
  name: 'Layout',
  components: {AppMain, Sidebar, NavMenu, NavBreadcrumb},
  data() {
    return {}
  },
  mixins: [adapter],
  mounted: function () {
  },
  computed: {
    ...mapState({
      showBreadcrumb: state => state.app.showBreadcrumb,
      sidebar: state => state.app.sidebar,
      showSettings: state => state.app.showSettings,
      affixHeader: state => state.app.affixHeader,
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.collapsed,
        openSidebar: this.sidebar.collapsed,
        withoutAnimation: this.sidebar.withoutAnimation,
      }
    },
  },
  methods: {}
}
</script>

<style lang="less" scoped>

@import '../assets/css/variables.less';

.app-wrapper {
  position: relative;
  height: 100%;
  width: 100%;

  .layout-nav {
    width: 100%;
    height: @topNavHeight!important;
    padding: 0 0 1px 0;
    margin: 0;
    //background: #FFFFFF;
    //border-bottom: 1px solid #efefef;
    box-sizing: border-box;
  }

  .body-container {
    height: calc(100% - @topNavHeight);
  }

  .breadcrumb {
    height: auto !important;
    //background-color: #FFFFFF;
    //border-bottom: 1px solid #efefef;
  }

  .top-index {
    z-index: 9;
  }
}

</style>
